import jwt_decode from 'jwt-decode';

export const getRolesFromToken = (accessToken: any) => {
  const jwtPayload: any = jwt_decode(accessToken);
  if (jwtPayload && jwtPayload.saras_claims) {
    return jwtPayload.saras_claims;
  } else {
    // invalid JWT token
    return null;
  }
};
